import { DadosPessoa } from "./dados-pessoa.model";

export class AlterarSenhaPessoa {

    novaSenha:string;
    confirmaNovaSenha:string;
    dadosPessoa: DadosPessoa = new DadosPessoa();
}


// WEBPACK FOOTER //
// ./src/app/models/account/alterar-senha-pessoa.model.ts